import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
	overflowX: 'auto',
	minWidth: 1100,
	height: '100%',
	maxHeight: '100%',
}));
